import { IDocumentObjectsInformationSection } from "./IDocumentObjectsInformation";
import { DocumentObjectsInformationObject } from "./DocumentObjectsInformationObject";

export class DocumentObjectsInformationSection implements IDocumentObjectsInformationSection {
  objects: DocumentObjectsInformationObject[];
}
